import React from 'react';

function createMutationObserverOnAttribute(
  selectors: string,
  callback: () => void,
) {
  const targetNode = document.querySelector(selectors);
  let cleanUpFn = () => {};

  if (targetNode) {
    const observer = new MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.type === 'attributes') {
          callback();
        }
      });
    });

    observer.observe(targetNode, { attributes: true });

    cleanUpFn = () => observer.disconnect();
  }

  return cleanUpFn;
}

const SPLITTER_SELECTOR = '.Pane1';
const SIDEBAR_SELECTOR = '.main-content';

function useAppResizeObserver(callback: () => void) {
  React.useEffect(() => {
    const cleanUpSplitterObserver = createMutationObserverOnAttribute(
      SPLITTER_SELECTOR,
      callback,
    );

    const cleanUpSidebarObserver = createMutationObserverOnAttribute(
      SIDEBAR_SELECTOR,
      callback,
    );

    return () => {
      cleanUpSplitterObserver();
      cleanUpSidebarObserver();
    };
  }, [callback]);
}

export default useAppResizeObserver;
